import { Component, Input, OnInit } from '@angular/core';
import { ExportItems, TypeFormats } from '../../../shared/types/exportItem';
import { ExportFileService } from '../../gamification/command-center/services/export-file.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Component({
  selector: 'cv-usage-stats-export-button',
  templateUrl: './usage-stats-export-button.component.html',
  styleUrls: ['./usage-stats-export-button.component.scss']
})
export class UsageStatsExportButtonComponent implements OnInit {
    @Input() startDate: string;
    @Input() endDate: string;
    @Input() gridData: any;
    @Input() columnStates: any;
    @Input() searchValue: string;

    public localizationDic: Map<string, string> = new Map();

    items: ExportItems = {
        excel: {
            getData: (format) => this.exportUsageStats(format),
        },
        csv: {
            getData: (format) => this.exportUsageStats(format),
        }
    };

    constructor(private exportService: ExportFileService, private locService: CVLocalizationService) { }

    ngOnInit(): void {
        this.initAsync();
    }

    async initAsync() {
        this.localizationDic = await this.locService.GetSection("Company_Usage_Stats");
    }

    async exportUsageStats(format: TypeFormats) {
        const url = `/api/v1/usagestatsgriddata/${this.startDate}/${this.endDate}/export?format=${format}`;

        return this.exportService.exportReportString(url, JSON.stringify({ usageStatsGridData: this.gridData, columnStates: this.columnStates, searchValue: this.searchValue }));
    };

    getLocalizationString(key, defaultValue) {
        if (this.localizationDic && this.localizationDic.has(key))
            return this.localizationDic.get(key);
        return defaultValue;
    }
}
